import {
    useMemo,
} from 'react'

import {
    useArchivedTableControl,
} from 'app/shared-components/TableControls/ShowArchived'
import Card from 'app/shared-components/Card'
import CollapsibleTable from 'app/shared-components/CollapsibleTable'
import useHasPermission from 'app/hooks/useHasPermission'

import requests from 'app/requests/ContractBasis/LaneGroup/LaneGroup.requests'
import useLaneGroupContext from '../../hooks/useLaneGroupContext'
import useGetLaneByLaneGroup from '../hooks/useGetLaneByLaneGroup'
import LaneUpdate from '../LaneUpdate'
import LaneCopy from '../LaneCopy'
import LaneCreate from '../LaneCreate'

import columns from './LanesTable.columns'
import useStyles from './LaneTable.styles'

const LanesTable = () => {
    const {
        classes,
    } = useStyles()
    const {
        laneGroupId,
    } = useLaneGroupContext()

    const createPermission = useHasPermission(['lane_create'])
    const showArchived = useArchivedTableControl('Lane')

    const requestsHandlers = useGetLaneByLaneGroup(laneGroupId, showArchived)

    const customUrl = useMemo(() => {
        return requests.getLaneByLaneGroup({
            laneGroupId,
        })?.url
    }, [laneGroupId])

    const actionComponents = useMemo(() => {
        return {
            Copy: createPermission ? LaneCopy : null,
            Update: LaneUpdate,
            Create: createPermission ? LaneCreate : null,
        }
    }, [createPermission])

    return (
        <div
            data-testid="LanesTable"
            className={classes.root}
        >
            <Card
                fullHeight
                contentClass={classes.cardContent}
                data-testid="LanesTable-card"
            >
                <CollapsibleTable
                    title="Lanes"
                    domainName="Lane"
                    columns={columns}
                    customUrl={customUrl}
                    requestHandlers={requestsHandlers}
                    actionComponents={actionComponents}
                    createEnabled={createPermission}
                />
            </Card>
        </div>
    )
}

export default LanesTable
